import { render, staticRenderFns } from "./Trial.vue?vue&type=template&id=bfd1736e&scoped=true&"
import script from "./Trial.vue?vue&type=script&lang=js&"
export * from "./Trial.vue?vue&type=script&lang=js&"
import style0 from "./Trial.vue?vue&type=style&index=0&id=bfd1736e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd1736e",
  null
  
)

export default component.exports